exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/* stylelint-disable */\n\n/* stylelint-enable */\n", ""]);

// exports
exports.locals = {
	"tiny-only": "\"screen and (max-width: 20.9375em)\"",
	"small-tiny": "\"screen and (max-width: 44.9375em)\"",
	"pre-medium": "\"screen and (min-width: 58em)\"",
	"tiny": "\"screen and (min-width: 21em)\"",
	"small": "\"screen and (min-width: 30em)\"",
	"medium": "\"screen and (min-width: 45em)\"",
	"large": "\"screen and (min-width: 64em)\"",
	"print": "\"print\"",
	"touch": "\"(hover: none) and (pointer: coarse)\"",
	"landscape-small": "\"screen and (orientation: landscape) and (max-height: 30em)\"",
	"ie": "\"all and (-ms-high-contrast: none), (-ms-high-contrast: active)\""
};